import FigmaDataIcon from './FigmaDataIcon';

interface Properties {
  width?: number;
  height?: number;
}

const ImportDataIconActive = ({ width = 16, height = 16 }: Properties) => {
  return <FigmaDataIcon width={width} height={height} color='#FFFFFF' />;
};

export default ImportDataIconActive;
